<template>
    <div class="search-btn" :style="`width:${initWidth?initWidth:70}px`">
        <i class="iconfont search-icon" @click="handleClick">&#xe6d1;</i>
        <el-input ref="searchInput" class="search-input" :placeholder="placeholder" v-model="searchValue"
                  @focus="onFocus" @blur.stop="searchEvent" @keydown.enter.native="$event.target.blur">
        </el-input>
    </div>
</template>

<script>
    export default {
        name: "SearchBtn",
        props: {
            searchFn: {
                type: Function,
                required: true,
            },
            currentPlaceholder: {
                type: String,
                required: false,
            },
            maxWidth: {
                type: Number,
                required: false,
            }
        },
        data() {
            return {
                isSearch: false,
                placeholder: '搜索',
                initWidth: 70,
                searchValue: '',
            }
        },
        methods: {
            onFocus() {
                this.placeholder = this.currentPlaceholder;
                this.initWidth = this.maxWidth ? this.maxWidth : 150;
            },
            handleClick() {
                this.isSearch = true;
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                })
            },
            searchEvent() {
                if (this.searchValue.length > 1) {
                    this.initWidth = this.maxWidth ? this.maxWidth : 150;
                } else {
                    this.placeholder = '搜索';
                    this.initWidth = 70;
                }
                this.searchFn(this.searchValue);
            }
        }
    }
</script>

<style scoped lang="scss">
    .search-btn {
        position: relative;

        .search-icon {
            color: $base-gray;
            position: absolute;
            top: 1px;
            left: 10px;
            height: 32px;
            line-height: 32px;
            z-index: 1001;
            cursor: text;
        }

        .search-input {
            display: flex;

            /deep/ .el-input__inner {
                font-size: 13px;
                text-indent: 18px;
            }
        }
    }
</style>